import React from 'react'
import bgImage from '../Assets/bhatti45.jpg';
const RightPage1 = () => {
  return (
    <div  id="home">
      
      <div>
      {/* Background Image */}
      <div
        className="w-[100%] min-h-screen bg-cover bg-no-repeat"
        style={{ backgroundImage: `url(${bgImage}) ` }}
      >
        <div className='pt-[40%] md:pt-[25%] '>
    <h1 className=' text-white md:pl-8  top-[200px] text-3xl md:text-5xl font-bold '>Talal Haider<p className='text-2xl'><br/>I'm <span className='text-blue-700'>Electrical Engineer</span></p></h1>
    
    </div>
    </div>
    </div>
      
    </div>
  )
}

export default RightPage1
